"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.navigation = void 0;
var ActionTypes = require("../actionTypes/navigation");
var initialState = {
    isOpen: false,
    isShrunk: false,
    isToolsSidebarOpen: false,
    confirmedNavigation: false,
    location: ''
};
var navigation = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case ActionTypes.TOGGLE_NAVIGATION_MENU:
            return __assign(__assign({}, state), { isOpen: !state.isOpen });
        case ActionTypes.TOGGLE_NAVIGATION_MENU_WIDTH:
            return __assign(__assign({}, state), { isShrunk: !state.isShrunk });
        case ActionTypes.CLOSE_NAVIGATION_MENU:
            return __assign(__assign({}, state), { isOpen: false });
        case ActionTypes.OPEN_NAVIGATION_MENU:
            return __assign(__assign({}, state), { isOpen: true });
        case ActionTypes.SET_CONFIRMED_NAVIGATION:
            return __assign(__assign({}, state), { confirmedNavigation: action.payload.x });
        case ActionTypes.SET_LOCATION:
            return __assign(__assign({}, state), { location: action.payload.location });
        case ActionTypes.CLEAR_NAVIGATION:
            return __assign(__assign({}, state), { location: '', confirmedNavigation: false });
        default:
            return state;
    }
};
exports.navigation = navigation;
